import { connect } from 'react-redux';
import { getIsAnonymized } from 'edrolo/domains/anonymizer';
import {
  getTopicLessons,
  loadCourseAssemblage,
} from 'edrolo/domains/bySchoolClass';
import TopicGrid from './TopicGrid';

const mapStateToProps = (state, ownProps) => {
  return {
    isAnonymized: getIsAnonymized(state),
    topicLessons: getTopicLessons(
      state,
      ownProps.classId,
      Number(ownProps.topicId)
    ),
  };
};

const mapDispatchToProps = (dispatch) => ({
  loadAssemblage: (classId) => dispatch(loadCourseAssemblage.signal(classId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TopicGrid);
